var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowIconRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.23392 2.63471C8.54634 2.32229 9.05288 2.32229 9.3653 2.63471L14.1653 7.43471C14.4777 7.74713 14.4777 8.25366 14.1653 8.56608L9.3653 13.3661C9.05288 13.6785 8.54634 13.6785 8.23392 13.3661C7.92151 13.0537 7.92151 12.5471 8.23392 12.2347L11.6682 8.80039L2.39961 8.80039C1.95778 8.80039 1.59961 8.44222 1.59961 8.00039C1.59961 7.55856 1.95778 7.20039 2.39961 7.20039H11.6682L8.23392 3.76608C7.92151 3.45366 7.92151 2.94712 8.23392 2.63471Z",
    fill: "#07070C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowIconRight);
export default __webpack_public_path__ + "static/media/arrowIcon-right.3c6d32bda68fab6f4cc33b5f6133f824.svg";
export { ForwardRef as ReactComponent };